module.exports = __webpack_public_path__ + "files/eb49efff8391e248c4698083f2f3a40c.svg";